<template>
    <div>
        <breadCrumb
            :icon="'fa-user-check'"
            :category="$t(`sideNav.navRoster`)"
            :subCategory="$t(`subMenu.roster_staff_scheme`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add Consent Form" @click="onAddForm">
                <span class="fal fa-plus mr-2"></span>
                <span>Add Scheme</span>
            </button>
        </div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <List
                        ref="list"
                        class="tab-pane"
                        @onStaffLoad="onStaffLoad"
                        @onStaffChange="onStaffChange"
                        @onEditForm="onEditForm">
                    </List>
                </div>
            </div>
        </div>
        <Form
            ref="form"
            @onDataChange="onDataChange">
        </Form>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import List from './List'
import Form from './Form'
import {
  handleSessionExpired,
} from "./../../../../assets/js/dashboard/dashboard";

export default {
    name: "consentForm",
    components: {
        List,
        Form,
        BreadCrumb,
    },
    data() {
        return {
            filterObj: {},
        }
    },
    methods: {
        onAddForm() {
            this.$refs['form'].showModal()
        },
        onEditForm(item) {
            this.$refs['form'].showModal(item)
        },
        onDeleteForm(item) {
            this.$refs['form'].showDeleteModal(item.consentID)
        },

        onStaffLoad(staffs) {
            this.$refs['form'].setStaffList(staffs)
        },
        onStaffChange(staff) {
            this.$refs['form'].setStaff(staff)
        },
        onDataChange() {
            this.$refs['list'].loadData()
        },
    },
    async mounted() {
        this.$axios({
            method: "get",
            url: 'https://staff.tunai.io/business/staff/leaves/type',
            headers: { token: this.$session.get("token") },
        })
            .then((response) => {
                this.leaveTypes = response.data.type
                this.$refs['form'].setLeaveTypes(this.leaveTypes)
            })
            .catch((err) => {
                var error = err.response.data.error;
                if (error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                }
            });
    }
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}
</style>